import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

function Title({ bannerTitle }) {
  const title = useSelector((state) => state.title)
  return (
    <section className=" inner-banner-wrapper">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col login-banner ">
            <div className="banner-content">
              <h1>{bannerTitle === '' ? title.sectionname : bannerTitle}</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
Title.propTypes = {
  bannerTitle: PropTypes.string.isRequired,
}

export default Title
